import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import TopHeader from '../../template/TopHeader';
import MarketingTopNav from '../MarketingTopNav';
import SocialPage from '../../marketing-v2/features/social/components/SocialPage';
import { SOCIAL_VISIBLE } from '../../../config/featureFlags';
import { keepFrom } from '../goUp';

import '../campaigns/Campaigns.css';

/**
 * Marketing › Social
 * Instagram and TikTok posts made from the salon's own diary, reviews, team
 * and photos, in their brand, with a calendar next to their campaigns.
 * Behind SOCIAL_VISIBLE (staging and below) until posts are kept on the
 * server; see docs/SOCIAL_BACKEND.md.
 */

function MarketingSocial(props) {
  // Arriving from Marketing home, the calendar or the diary with "make a
  // post" opens New post: for that day, when one was picked, and from the
  // diary's stylist menu at that stylist's free times. Only the first open;
  // Create afterwards starts afresh.
  const arrived = props.location && props.location.state;
  const [createSignal, setCreateSignal] = useState(arrived && arrived.create ? 1 : 0);
  const [arrival] = useState(() => (arrived && arrived.create ? {
    day: arrived.day || null,
    type: arrived.type || null,
    staffId: arrived.staffId || null,
    staffName: arrived.staffName || null,
    // From a discount code's Share: an offer with that code on
    codeId: arrived.codeId || null,
  } : null));
  // From Bailey: a post it made and saved, opened straight in the studio
  const [openPostId] = useState(() => (arrived && arrived.openPostId ? String(arrived.openPostId) : null));
  // Read once: a reload doesn't open it all again (as Campaigns does)
  useEffect(() => {
    if (!arrived || !props.history || !props.location) return;
    const { pathname, search, hash } = props.location;
    // Only what was asked for is spent; where Back goes (from) stays
    props.history.replace({ pathname, search, hash, state: keepFrom(props.location) });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!SOCIAL_VISIBLE) return <Redirect to="/marketing-campaigns" />;

  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="social">
            <button type="button" className="catalogue-add-btn" onClick={() => setCreateSignal((n) => n + 1)}>
              Create
            </button>
          </MarketingTopNav>
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="cmp-wrap sx-shell">
                    <div className="cmp-head">
                      <div className="cmp-head-text">
                        <h1 className="cmp-title">Social</h1>
                        <p className="cmp-subtitle">
                          Posts for Instagram and TikTok, made from what’s happening in your salon.
                        </p>
                      </div>
                    </div>
                    <SocialPage dispatch={props.dispatch} user={props.user} history={props.history} createSignal={createSignal} createPlan={createSignal === 1 ? arrival : null} openPostId={openPostId} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(mapStateToProps)(MarketingSocial);
